import { Box, Button } from "@mui/material";
import { SubscriptionContext, SubscriptionTab } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

import { B2GO_PROMO_END } from "constants/influencer";

import BannerWrapper from "../BannerWrapper";

const B2GO_STRIP_TARGET = B2GO_PROMO_END.getTime();

const pad = (n: number) => String(n).padStart(2, "0");

const useStripCountdown = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  let diff = Math.max(0, B2GO_STRIP_TARGET - now);
  const d = Math.floor(diff / 86_400_000);
  diff -= d * 86_400_000;
  const h = Math.floor(diff / 3_600_000);
  diff -= h * 3_600_000;
  const m = Math.floor(diff / 60_000);
  diff -= m * 60_000;
  const s = Math.floor(diff / 1_000);
  return { d, h, m, s };
};

const B2GOPromoStrip = () => {
  const { setTab, setUpgradeDialogSource } = useContext(SubscriptionContext);
  const { d, h, m, s } = useStripCountdown();

  const claim = () => {
    setTab(SubscriptionTab.quarterly);
    setUpgradeDialogSource(UpgradeDialogSource.b2go_banner);
  };

  return (
    <BannerWrapper onClick={claim}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 1, md: 1.25 },
          fontSize: { xs: 12.5, md: 14 },
          whiteSpace: "nowrap",
        }}
      >
        <Box
          component="i"
          className="fa-solid fa-gift"
          sx={{ color: "yellow.main", fontSize: { xs: 14, md: 16 } }}
        />
        <Box component="span">
          <Box
            component="b"
            sx={{ fontWeight: 600, display: { xs: "none", md: "inline" } }}
          >
            Buy 2 months, get your 3rd free
          </Box>
          <Box
            component="b"
            sx={{ fontWeight: 600, display: { xs: "inline", md: "none" } }}
          >
            Buy 2, get 1 free
          </Box>
          <Box
            component="span"
            sx={{ display: { xs: "none", md: "inline" }, opacity: 0.8 }}
          >
            {" "}
            — B2GO promo ends soon
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: "none", md: "inline-flex" },
          alignItems: "center",
          gap: 0.875,
          fontWeight: 600,
          fontVariantNumeric: "tabular-nums",
          backgroundColor: "rgba(255,255,255,0.1)",
          border: "1px solid rgba(255,255,255,0.14)",
          borderRadius: "999px",
          px: 1.5,
          py: 0.5,
          fontSize: 13,
        }}
      >
        <Box
          component="i"
          className="fa-solid fa-clock"
          sx={{ color: "yellow.main", fontSize: 13 }}
        />
        {pad(d)}d : {pad(h)}h : {pad(m)}m : {pad(s)}s
      </Box>

      <Button
        onClick={claim}
        disableElevation
        sx={{
          backgroundColor: "yellow.main",
          color: "green.dark",
          fontWeight: 600,
          fontSize: { xs: 12, md: 13 },
          borderRadius: "999px",
          px: { xs: 1.5, md: 2.25 },
          py: 0.625,
          textTransform: "none",
          whiteSpace: "nowrap",
          minWidth: "auto",
          "&:hover": {
            backgroundColor: "yellow.main",
            filter: "brightness(0.93)",
          },
        }}
      >
        Claim free month
      </Button>
    </BannerWrapper>
  );
};

export default B2GOPromoStrip;
